import { __awaiter } from '../../_virtual/_tslib.js';
import { useQueryClient, useInfiniteQuery } from 'react-query';
import { validateAndConvertReqParamToInt } from '../utils/validateAndConvertReqParamToNum.js';
import { getAuthIdParam } from '../../methods/getAuthIdParam.js';
import API from '../const.js';
import { getAuthHeader } from '../utils/getAuthHeader.js';
import { getInfiniteQueryCurrentDataLength } from '../utils/getInfiniteQueryCurrentDataLength.js';
import { QueryNames } from './queryNames.js';
import '../../constants/authorizedUsers.js';
import '../../constants/bidStatus.js';
import '../../constants/bulkLoadCardStatus.js';
import '../../constants/misc.js';
import '../../constants/event-names.js';
import '../../constants/eventsMapObj.js';
import '../../constants/Faq.js';
import '../../constants/languages.js';
import '../../constants/loadStatus.js';
import '../../constants/lorryStatus.js';
import '../../constants/lorryTypes.js';
import '../../constants/mostSearchedLinks.js';
import '../../constants/Pages.js';
import 'bowser';
import '../../components/toast/toast.js';
import '../auth.service.js';
import 'react';
import 'react-cookie';
import '../../methods/formatDate.js';
import '../../constants/StateList.js';
import '../../methods/getTransporterFigure.js';
import '../../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../../methods/getPageLoadSourceUTMParam.js';
import 'crypto-js';
import '../../constants/serviceTypeId.js';
import '../../constants/bidUpdateType.js';
import '../../constants/userAction.js';
import { API_REQUEST_TYPE } from '../../constants/api.js';
import '../../constants/link.js';
import '../../constants/market.js';
import '../../constants/payment.js';
import '../../constants/admin/screenId.js';

function useGetLorriesForCurrentUserQuery({ companyId, type, status, request_type = API_REQUEST_TYPE.ELASTIC_SEARCH, created_at_string, id, preloads = [] }, { enabled, refetchInterval, onSuccess }) {
    const queryClient = useQueryClient();
    const { data, fetchNextPage, hasNextPage, isFetching, isLoading, refetch } = useInfiniteQuery([QueryNames.lorrySearch, companyId, type, status, request_type, created_at_string, id], ({ pageParam = 1 }) => __awaiter(this, void 0, void 0, function* () {
        const validatedCompanyId = validateAndConvertReqParamToInt("companyId", companyId);
        if (!validatedCompanyId) {
            return { results: [], next: undefined };
        }
        const response = yield fetch(API.ALL_LORRIES + getAuthIdParam(), {
            body: JSON.stringify({
                company_id: validatedCompanyId,
                page_number: pageParam,
                request_type,
                status,
                created_at_string,
                type,
                id,
                preload: ["bid_infos", "company_detail", "lorry_details", ...preloads]
            }),
            method: "POST",
            headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, getAuthHeader())
        });
        if (response.status === 401) {
            // this will cause the AuthVerifyComp to re-render and when token verification fails, logout the app
            queryClient.invalidateQueries(QueryNames.validateToken);
        }
        if (!response.ok) {
            throw new Error("Problem fetching data");
        }
        const dataFromServer = yield response.json();
        const data = {
            results: dataFromServer.data.lorry_cards,
            totalCount: dataFromServer.data.total_records,
            next: pageParam < dataFromServer.data.total_pages ? pageParam + 1 : undefined
        };
        return data;
    }), {
        getNextPageParam: (lastPage) => lastPage.next,
        refetchInterval: refetchInterval || false,
        enabled,
        onSuccess: (data) => {
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
        }
    });
    return {
        data,
        fetchNextPage,
        hasNextPage,
        currentDataLength: getInfiniteQueryCurrentDataLength(data),
        isFetching,
        isLoading,
        refetch
    };
}

export { useGetLorriesForCurrentUserQuery };
//# sourceMappingURL=useLorryMarketService.js.map
